import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ToastService } from '../toast.service';

interface Transaction {
  id: string;
  transaction_id: string;
  type: 'debit' | 'credit';
  retailer_name: string;
  amount: number;
  payment_method: string;
  status: 'success' | 'pending' | 'failed';
  transaction_date: string;
  gateway_payment_id: string | null;
  invoice_no: string | null
}

@Component({
  selector: 'app-invoice-transactions-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './invoice-transactions-modal.component.html',
  styleUrls: ['./invoice-transactions-modal.component.scss']
})
export class InvoiceTransactionsModalComponent implements OnInit {
  @Input() invoiceId!: string;
  @Input() invoiceNo!: string;
  @Input() userType!: string;
  @Output() close = new EventEmitter<void>();

  transactions: Transaction[] = [];
  loading = false;

  constructor(
    private http: HttpClient,
    private toastService: ToastService
  ) { }

  ngOnInit() {
    this.fetchTransactions();
  }

  fetchTransactions() {
    this.loading = true;

    let url = `${environment.apiBaseUrl}/transaction/all?invoice_id=${this.invoiceId}`;
    if (this.userType === 'distributor') {
      url = `${environment.apiBaseUrl}/distributor/transactions?invoice_id=${this.invoiceId}`;
    }

    this.http.get<any>(url).subscribe({
      next: (res) => {
        this.loading = false;
        if (res.statusCode === 200 && res.data) {
          const apiData = res.data.data || [];
          this.transactions = apiData.map((txn: any) => ({
            id: txn.id,
            transaction_id: txn.id,
            type: txn.is_refund ? 'credit' : 'debit',
            retailer_name: txn.retailer_name || txn.fromRetailer?.retailer_name || 'N/A',
            amount: Number(txn.amount),
            payment_method: txn.payment_mode,
            status: txn.status,
            transaction_date: txn.created_at,
            gateway_payment_id: txn.gateway_payment_id,
            invoice_no: txn.invoice_no
          }));
        } else {
          this.toastService.error('Failed to fetch transactions');
        }
      },
      error: (err) => {
        this.loading = false;
        this.toastService.error(err?.error?.message || 'Failed to fetch transactions');
      }
    });
  }

  closeModal() {
    this.close.emit();
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'success': return 'status-success';
      case 'pending': return 'status-pending';
      case 'failed': return 'status-failed';
      default: return '';
    }
  }

  getTypeClass(type: string): string {
    return type === 'credit' ? 'type-credit' : 'type-debit';
  }
}
